<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pV"></a><i>Contents</i></p>
<p class="contents"><a href="#/acknowledgments.htm#ack">Acknowledgments</a></p>
<p class="contents"><a href="#/translators_acknowledgments.htm#ack1">Translator’s Acknowledgments</a></p>
<p class="contents"><a href="#/introduction.htm#intro">Introduction</a></p>
<p class="contents"><a href="#/map.htm#map">Map of the Western Front, August 1914</a></p>
<p class="contents"><a href="#/ch1.htm#ch1"><span class="fsc">ONE.</span> War Breaks Out</a></p>
<p class="contents"><a href="#/ch2.htm#ch2"><span class="fsc">TWO.</span> Visions of War, Dreams of Peace</a></p>
<p class="contents"><a href="#/ch3.htm#ch3"><span class="fsc">THREE.</span> Farewell Ceremonies</a></p>
<p class="contents"><a href="#/ch4.htm#ch4"><span class="fsc">FOUR.</span> Trial by Fire</a></p>
<p class="contents"><a href="#/ch5.htm#ch5"><span class="fsc">FIVE.</span> The Shadow of Defeat</a></p>
<p class="contents"><a href="#/ch6.htm#ch6"><span class="fsc">six.</span> The Enemy Within</a></p>
<p class="contents"><a href="#/ch7.htm#ch7"><span class="fsc">SEVEN.</span> Fears and Rumors</a></p>
<p class="contents"><a href="#/ch8.htm#ch8"><span class="fsc">EIGHT.</span> The Sounds of War</a></p>
<p class="contents"><a id="pVI"></a><a href="#/epilogue.htm#epi">Epilogue: Beyond August 1914</a></p>
<p class="contents"><a href="#/timeline.htm#time">Timeline</a></p>
<p class="contents"><a href="#/notes.htm#notes">Notes</a></p>
<p class="contents"><a href="#/index.htm#index">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b1dbcd2a